/* 🤖 this file was generated by svg-to-ts*/
export const IconFiberManualRecord = {
    name: 'fiberManualRecord',
    data: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8" fill="currentColor" fill-rule="evenodd"/></svg>'
};
